import React from "react";
import { ROW_H } from "./constants";
import GridLayout, { WidthProvider } from "react-grid-layout";

const RGL = WidthProvider(GridLayout);

export default function GridCanvas({
  layout,
  setLayout,
  alignMode,
  onPushHistory,
  onApplyItem,
  children,
}) {
  const apply = (l) => {
    const next = onApplyItem ? l.map(onApplyItem) : l;
    setLayout(next);
  };

  return (
    <div data-rgl-scope className="relative">
      {/* 스코프된 스타일: 이 컴포넌트 내부에서만 적용 */}
      <style>{`
        [data-rgl-scope] .react-resizable-handle {
          z-index: 30;
          pointer-events: auto;
          width: 12px;
          height: 12px;
        }
       [data-rgl-scope] .react-resizable-handle-se {
         right: 2px;
         bottom: 2px;
       }
       [data-rgl-scope] .react-resizable-handle-se::after {
         content: "";
         position: absolute;
         right: 0; bottom: 0;
         width: 0; height: 0;
         border-right: 8px solid currentColor;
         border-top: 8px solid transparent;
         opacity: .45;
       }
       /* TinyMCE가 핸들을 덮지 않도록 (이 스코프 안에서만) */
       [data-rgl-scope] .tox { z-index: 0; }
     `}</style>

      <RGL
        className="layout"
        cols={12}
        rowHeight={ROW_H}
        margin={[12, 12]}
        containerPadding={[12, 12]}
        useCSSTransforms={!alignMode}
        isDraggable={alignMode}
        isResizable={alignMode}
        resizeHandles={["e", "w", "se", "sw", "s"]}
        compactType={null}
        preventCollision={alignMode}
        layout={layout}
        onLayoutChange={apply}
        onDragStop={(l) => {
          onPushHistory?.();
          apply(l);
        }}
        onResizeStop={(l) => {
          onPushHistory?.();
          apply(l);
        }}
        draggableHandle=".grab-handle"
        draggableCancel=".mce-content-body, .tox, textarea, input, .no-drag, .tox-tinymce, .tox-editor-container, button, [role='button']"
        style={{ position: "relative" }}
      >
        {children}
      </RGL>
    </div>
  );
}
